/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e568423ff411faf403527c5bbb3a119>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ArrowCurvedDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/arrow-curved-down-left
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ArrowCurvedDownLeftIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "ArrowCurvedDownLeftIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6a3 3 0 0 1-3 3H3.56l3.22-3.22-1.06-1.06-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06-3.22-3.22h6.94A4.5 4.5 0 0 0 15 6V1h-1.5z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ArrowCurvedDownLeftIcon.displayName = 'ArrowCurvedDownLeftIcon';
var _default = exports.default = ArrowCurvedDownLeftIcon;